// extracted by css-extract-rspack-plugin
export default {"Well":"akCUR","isActive":"MpQsV","isOver":"Ey3Y0","defaultBorderRadius":"UwHQN"};